import { render, staticRenderFns } from "./FactorClassScore.vue?vue&type=template&id=c541d57a&scoped=true&"
import script from "./FactorClassScore.vue?vue&type=script&lang=ts&"
export * from "./FactorClassScore.vue?vue&type=script&lang=ts&"
import style0 from "./FactorClassScore.vue?vue&type=style&index=0&id=c541d57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c541d57a",
  null
  
)

export default component.exports